"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCreateNewConversation(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 19"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1BBBC9",
    d: "M9 1a9 9 0 110 18A9 9 0 019 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1BBBC9",
    d: "M4 6.477h4v7H4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M7.713 6.5a.2.2 0 00-.2.2L7.5 12.3c0 .11.09.2.2.2h6.6a.2.2 0 00.2-.2V6.7a.2.2 0 00-.2-.2H7.713z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1BBBC9",
    d: "M5 7h3v5H5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    d: "M8 7l2.966 2L14 7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.4 6.477h1v6h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8 8.877v1H2v-1z"
  })));
}

var MemoSvgCreateNewConversation = /*#__PURE__*/React.memo(SvgCreateNewConversation);
var _default = MemoSvgCreateNewConversation;
exports["default"] = _default;